export default __webpack_public_path__ + "static/media/3.2.432671f2.jpeg";